"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var People = function People(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "PeopleTitle PeopleDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "PeopleTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "PeopleDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M15.32 12.82c.72 0 1.52.107 2.4.32.973.253 1.767.58 2.38.98.72.48 1.08 1.02 1.08 1.62v2.08h-5v-2.08c0-1.133-.547-2.093-1.64-2.88.187-.027.447-.04.78-.04zm-6.64 0c.72 0 1.513.107 2.38.32.973.253 1.76.58 2.36.98.72.48 1.08 1.02 1.08 1.62v2.08H2.82v-2.08c0-.6.36-1.14 1.08-1.62.613-.4 1.407-.727 2.38-.98.88-.213 1.68-.32 2.4-.32zm0-1.64a2.41 2.41 0 0 1-1.24-.34 2.536 2.536 0 0 1-.92-.92 2.41 2.41 0 0 1-.34-1.24c0-.44.113-.853.34-1.24.227-.387.533-.693.92-.92a2.412 2.412 0 0 1 2.47 0c.38.227.68.53.9.91.22.38.33.797.33 1.25 0 .453-.11.87-.33 1.25-.22.38-.52.683-.9.91-.38.227-.79.34-1.23.34zm6.64 0a2.41 2.41 0 0 1-1.24-.34 2.536 2.536 0 0 1-.92-.92 2.41 2.41 0 0 1-.34-1.24c0-.44.113-.853.34-1.24.227-.387.533-.693.92-.92.387-.227.8-.34 1.24-.34.44 0 .853.113 1.24.34.387.227.693.533.92.92.227.387.34.8.34 1.24 0 .44-.113.853-.34 1.24a2.536 2.536 0 0 1-.92.92c-.387.227-.8.34-1.24.34z",
    id: "refPeopleRuuSGJz0Ip6"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refPeopleRuuSGJz0Ip6",
    fillRule: "evenodd"
  }));
};

People.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
People.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = People;
exports["default"] = _default;